// extracted by mini-css-extract-plugin
module.exports = {"label":"Repeat_label__3Dd2x"};